module.exports = __webpack_public_path__ + "static/media/star-bad.c8774fbc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/newDropshipperApp/images/star-bad.svg
// module id = 2177
// module chunks = 0